module.exports = __webpack_public_path__ + "img/settings.3f0a9d43.svg";